var LocalStoragePreferredDeviceStorage = /** @class */ (function () {
    function LocalStoragePreferredDeviceStorage(storageKey) {
        if (storageKey === void 0) { storageKey = 'preferredDeviceId'; }
        var _this = this;
        this.storageKey = storageKey;
        this.setDeviceId = function (trackType, deviceId) {
            localStorage.setItem("".concat(_this.storageKey, "_").concat(trackType), deviceId || '');
        };
        this.getDeviceId = function (trackType) {
            return localStorage.getItem("".concat(_this.storageKey, "_").concat(trackType)) || null;
        };
    }
    return LocalStoragePreferredDeviceStorage;
}());
export { LocalStoragePreferredDeviceStorage };
//# sourceMappingURL=PreferredDeviceStorage.js.map